export const GET_COUPONS = "GET_COUPONS";
